import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LogInButton from 'flarum/forum/components/LogInButton';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import { handleOAuthCallback } from '../../../../devconnect-oauth-core/js/src/forum/service/OAuthCallbackHandler';
import SocialAccountItem from '../../../../devconnect-oauth-core/js/src/forum/components/SocialAccountItem';
const settingsPageComponent = 'flarum/forum/components/SettingsPage';
app.initializers.add('devconnect-oauth-vk', () => {
  extend(LogInButtons.prototype, 'items', items => {
    // Кнопка не показывается до настройки приложения VK ID, поэтому пользователь не попадает в тупиковый сценарий.
    if (app.forum.attribute('devconnectOauthVkEnabled')) {
      items.add('devconnect-vk', m(LogInButton, {
        className: "Button LogInButton--vk",
        icon: "fab fa-vk",
        path: `/auth/vk?return=${encodeURIComponent(window.location.href)}`
      }, app.translator.trans('devconnect-oauth-vk.forum.log_in')), 90);
    }
  });
  extend(settingsPageComponent, 'accountItems', items => {
    items.add('devconnect-vk-account', m(SocialAccountItem, {
      provider: "vk",
      icon: "fab fa-vk",
      configuredAttribute: "devconnectOauthVkEnabled",
      linkingAttribute: "devconnectOauthVkLinkingEnabled",
      linkedAttribute: "devconnectOauthVkLinked",
      title: app.translator.trans('devconnect-oauth-vk.forum.account_title'),
      linkedText: app.translator.trans('devconnect-oauth-vk.forum.account_linked'),
      notLinkedText: app.translator.trans('devconnect-oauth-vk.forum.account_not_linked'),
      connectText: app.translator.trans('devconnect-oauth-vk.forum.connect'),
      disconnectText: app.translator.trans('devconnect-oauth-vk.forum.disconnect'),
      disconnectConfirmText: app.translator.trans('devconnect-oauth-vk.forum.disconnect_confirm'),
      disconnectedText: app.translator.trans('devconnect-oauth-vk.forum.disconnected'),
      disconnectErrorText: app.translator.trans('devconnect-oauth-vk.forum.disconnect_error')
    }), 70);
  });

  // Flarum создаёт модель форума после initializers, поэтому callback запускается на штатной стадии beforeMount.
  app.beforeMount(() => handleOAuthCallback(app, app.translator.trans('devconnect-oauth-vk.forum.session_expired'), app.translator.trans('devconnect-oauth-vk.forum.linked_success')));
});